import type { OrderStatus } from '@/types/enums'
import i18n from '@/utils/i18n'

/** Подписи этапов как в мобильном (ADMIN_UX §19) */
export function mobileStageLabel(status: OrderStatus): string {
  return i18n.t(`stageLabel.${status}`)
}
